<template>
  <input style="min-height:86px;" :disabled="disabled" />
</template>

<script>
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/src/tagify.scss";
export default {
  name: "tagify",
  props: {
    mode: String,
    settings: Object,
    disabled: Boolean
  },

  mounted() {
    this.tagify = new Tagify(this.$el, this.settings);
  }
};
</script>





